import type { FC } from 'react';

import type { IconProps } from './type';

export const CheckedIcon: FC<IconProps> = (props) => {
  return (
    <svg fill="none" viewBox="0 0 65 53" {...props}>
      <path
        clipRule="evenodd"
        d="M62.6507 2.59005C65.1711 5.33966 65.1711 9.79768 62.6507 12.5473L28.2288 50.0984C25.7083 52.848 21.6218 52.848 19.1013 50.0984L1.89036 31.3229C-0.630121 28.5732 -0.630121 24.1152 1.89036 21.3656C4.41085 18.616 8.49736 18.616 11.0178 21.3656L23.665 35.1626L53.5232 2.59005C56.0437 -0.159573 60.1302 -0.159573 62.6507 2.59005Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
